export const API_DEFAULT_PREFIX = '/api';
export const API_DEFAULT_VERSION = '/v1';

export const REST_API = {
  ACCESS_REQUEST: '/accessrequests/',
  ACCESS_REQUEST_APPROVE: '/accessrequests/{id}/approve',
  ACCESS_REQUEST_DENY: '/accessrequests/{id}/deny',
  SENSOR_MODEL: '/sensormodels/',
  SENSOR_EQUIPMENT_ASSOCIATE_TO_MODEL: '/sensorequipmentformodel/',
  SENSOR_TYPES: '/sensortypes/',
  WEATHER_STATIONS: '/weatherstations/',
  WEATHER_STATIONS_AREAS: '/weatherstations/areas/',
  WEATHER_STATION: '/weatherstation/',
  SENSOR_EQUIPMENT_ASSOCIATE: '/sensorequipment?query.availableOnly=true',
  SENSOR_EQUIPMENT_ASSOCIATE_TO_WEATHER_STATION: '/SensorEquipment/Associate/',
  SENSOR_EQUIPMENT: 'sensorequipment/',
  SOIL_TYPES: '/soiltypes/',
  CODE_TABLE: '/meaningfulobservationvalues/',
  PLACEMENT_SOIL_LAYER: '/placementsoillayer/',
  OBSERVATION_TYPES: '/observationtypes/',
  OBSERVATION_TYPE_CATEGORIES: 'observationtypecategories',
  ROLES: '/roles/',
  CAMERA_EQUIPMENT: '/cameraequipment/',
  CAMERA_VIEW: '/cameraview/',
  OBSERVATIONS: '/observations/',
  OBSERVATIONS_VALIDATION: '/observations/valid/',
  OBSERVATIONS_VALIDATION_HIST: '/observations/valid_history/',
  OBSERVATIONS_VALIDATION_BULK: '/observations/bulk/',
  DERIVED_OBSERVATION: '/observationtypes/allderivedobservationtypeids',
  GRAPH_VIEWS: '/graph-views/',
  GRAPH_PRESETS: '/graphpreset/',
  INGESTION_FAILURES: '/ingestionfailures/',
  INGESTION_FAILURE: '/ingestionfailure/',
  DATASETS_BY_WEATHER_STATION: '/datasets/by-weather-stations/',
  FORECAST_ISSUED_TIMES: '/dataVisualization/weathernetforecasts/',
  FORECAST_ISSUED_TEXT: '/dataVisualization/weatherforecast/',
  USERS: '/users/',
  MY_PROFILE: '/users/my/profile',
  MY_PRESETS: '/users/my/presets',
  DASHBOARD_VIEWS: '/dashboard-views/',
  AVA_DASHBOARD_VIEWS: '/ava-dashboard-views/',
  AVA_FAILED_DASHBOARD_VIEW: '/ava-failed-dashboard-views/',
  REGIONS: '/regions/',
  EET_REGIONS: '/eetgeographicareas/',
  AVA_MONITOR_PROGRAMS: '/avamonitorgeographicprograms/',
  DROPDOWNS: '/dropdowns/',
  SENSOR_OBSERVATION_TYPES: '/segmentobservationtypes/',
  MULTI_DATA_VISUALIZATION: '/mutiDataVisualization/',
  DATA_VISUALIZATION: '/datavisualization/',
  DATA_VISUALIZATION_OBSERVATION_TYPES: '/datavisualization/observationtypes/',
  DATA_VISUALIZATION_MEANINGFUL_VALUES: 'dataVisualization/meaningfulobservationvalues/',
  DATA_VISUALIZATION_ISSUED_WEATHERNET: '/datavisualization/issuedweathernetforecast/',
  DATA_VISUALIZATION_VALIDATION_RULES: '/datavisualization/validationrules/',
  MANUFACTURERS: '/manufacturers/',
  PLACEMENT_TEMPLATES: '/placementTemplates/',
  PLACEMENT_TEMPLATE: '/placementTemplate/',
  AVALANCHE: '/avalanche/',
  INGESTION_CANDIDATE: '/ingestioncandidate/',
  INGESTION_CANDIDATE_BY_TRACEID: '/ingestioncandidatebytraceid/',
  EVENT_PROPERTY: '/event/properties',
  EVENT_TYPES: '/event/types',
  TILES: '/maps/tiles/{z}/{y}/{x}',
  MAP_DATA: '/maps/mapdata?dummy=dummy',
  PROCESSED_ROAD_CLOSURE: '/avalanche/processedevents/roadclosures/',
  PROCESSED_PHASED: '/avalanche/processedevents/phased/',
  PROCESSED_OCCURRENCE: '/avalanche/processedevents/occurrences/',
  PROCESSED_CONTROL: '/avalanche/processedevents/controls/',
  PROCESSED_LINKED_EVENTS: '/avalanche/processedevents/linkedevents/',
  NOTIFICATIONS: '/notifications/',
  HAZARD_FORECAST: '/hazardforecast/',
  HAZARD_FORECAST_AREAS: '/hazardforecastareas/',
  AVALANCHE_EVENT: '/avalanche/event/',
  NON_SPATIAL_REFERENCE_DATA: '/nonspatialreferencedata/',
  AVALANCHE_PATH: '/nonspatialreferencedata/avalanchepath/',
  HAZARD_FORECAST_ANALYSIS: '/hazardforecastanalysis/',
  HAZARD_FORECAST_RAW_WEATHER_OBSERVATION: '/hazardforecastrawweatherobservation/',
  HAZARD_FORECAST_WEATHER_OBSERVATION: '/hazardforecastweatherobservation/',
  FORECAST_RECIPIENTS: '/users/forecastrecipients/',
  SYSTEM_NOTIFICATIONS: '/systemnotifications/',
  GATEWAY_USER: '/users/gatewayuser/',
  VMS: '/vms/variablemessagesign/',
  VMS_VIEW: '/vms/variablemessagesigns/',
  VMS_STATE: '/vms/state/',
  VMS_STATE_LIST: '/vms/statelist/',
  VMS_DETAILED_INFO: '/vms/detailedinfo',
  VMS_TIMER: '/vms/timer',
  OBSERVATION_TYPES_USED_BY_SEGMENTS: '/weatherstations/observationtypesusedbysegments',
  SYSTEM_NOTIFICATION_MESSAGES: '/systemnotificationmessages/',
  SYSTEM_NOTIFICATION_MESSAGE: '/systemnotificationmessages/select/',

  STANDARD_GRAPH_AXIS: `/observationtypes/standardgraphaxis`,
  UNIT_OF_MEASURES: '/observationtypes/unitofmeasures',
};

export const STATE_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  SUCCESS: 'succeeded',
  FAILED: 'failed',
};

export const Views = {
  AccessRequest: '/AccessRequest/',
  Avalanche: '/Avalanche/',
  AvalancheMonitor: '/avalancheMonitor/',
  AvalancheProcessedEvent: '/AvalancheProcessedEvent/',
  Dashboard: '/dashboard/',
  DataTable: '/DataTables',
  ForecastRecipient: '/forecastRecipient',
  AvalancheAreas: '/AvalancheAreas',
  AvalanchePaths: '/AvalanchePaths',
  AvalanchePrograms: '/AvalanchePrograms',
  FrostProbe: '/FrostProbe',
  GraphPresets: '/GraphPresets',
  HazardForecast: '/ProcessedHazardForecastEdit/',
  HazardForecastArea: '/HazardForecastArea',
  HazardForecastTemplate: '/HazardForecastTemplate',
  IngestionFailure: '/IngestionFailures/',
  ManualDataValidation: '/ManualDataValidation',
  Manufacturer: '/Manufacturers/',
  Maps: '/Maps/',
  MultiStationGraph: '/MultiStation',
  MyProfile: '/MyProfile/',
  Notification: '/notifications/',
  ObservationType: '/ObservationTypes/',
  RoadClosureLocations: '/RoadClosureLocations',
  RoadClosureAreas: '/RoadClosureAreas',
  Role: '/Roles/',
  SensorEquipment: '/SensorEquipment/',
  SensorModel: '/SensorModels/',
  SoilType: '/SoilType/',
  SensorType: '/SensorTypes/',
  SingleStationGraph: '/SingleStation',
  StandardGraphAxis: '/StandardGraphAxis',
  User: '/users/',
  UserPreferences: '/UserPreferences/',
  Vms: '/Vms/',
  VmsControl: '/VmsControl/',
  WeatherStation: '/WeatherStations/',
};

export const ENTITY_TITLES = {
  AVALANCHE_PATHS: 'Avalanche Paths',
  AVALANCHE_PATH: 'Avalanche Path',
  AVALANCHE_PROGRAMS: 'Avalanche Programs',
  AVALANCHE_PROGRAM: 'Avalanche Program',
  GRAPH_PRESET: 'Graph Preset',
  GRAPH_PRESETS: 'Graph Presets',
  HAZARD_FORECAST_AREA: 'Hazard Forecast Area',
  HAZARD_FORECAST_AREAS: 'Hazard Forecast Areas',
  HAZARD_FORECAST_TEMPLATES: 'Hazard Forecast Templates',
  MANUFACTURER: 'Manufacturer',
  MANUFACTURERS: 'Manufacturers',
  STANDARD_GRAPH_AXIS: 'Standard Graph Axis',
};

export const BREAD_CRUMB_NAMES = {
  AVALANCHE_EVENTS_LIST: 'Avalanche Events List',
  PROCESSED_EVENTS_LIST: 'Processed Events List',
};

export const WEATHER_STATION_URLS = {
  VIEW: '/WeatherStations/',
  DETAILS: '/WeatherStations/details/',
  EDIT: '/WeatherStations/edit/',
  CREATE: '/WeatherStations/Create/',
  SENSOR_EQUIPMENT_ASSOCIATE_VIEWS: '/WeatherStations/Associate/',
  CAMERA_VIEWS: '/cameraview-by-weather-station/',
};

export const SENSOR_EQUIPMENT_URLS = {
  VIEW: '/SensorEquipment/',
  DETAILS: '/SensorEquipment/details/',
  EDIT: '/SensorEquipment/edit/',
  CREATE: '/SensorEquipment/Create/',
};

export const DATA_TABLES_MSG = {
  NO_VALID_DATA: 'No valid data to display',
  NO_INVALID_DATA: 'No invalid data to display',
  NO_DATA: 'No data to display',
  NO_DATA_SELECTED: 'No data selected to display',
};

export const VIEW_ACTIONS = {
  ADD: 'add_view',
  DELETE: 'delete_view',
  DISCARD: 'discard_chagnes',
  SAVE: 'save_view',
  SAVE_AS: 'save_view_as',
};

export const BLANK_VIEW_NAME = 'Custom View';
export const FAKE_SEPARATOR = 'Separator';

export const DEFAULT_PAGE_SIZE = 25;

export const RISK_CODE_COLOURS = {
  0: '#117733', // Green Normal
  1: '#fdca44', // Yellow Warning
  2: '#dc3220', // Red  Alarm
  3: '#fdca44', // Yellow Warning
  4: '#fdca44', // Yellow Warning
  5: '#117733', // Green Normal
  6: '#fdca44', // Yellow Warning
  7: '#dc3220', // Red  Alarm
  8: '#33acb9', //Blue
  9: '#767676', //Grey
};

export const GRAPH_COLORS = [
  '#1a85ff', // Blue
  '#d35fb7', // Pink
  '#22c244', // Green
  '#4b0092', // Deep purple
  '#994f00', // Brown
];

export const GRAPH_TAB_KEY = {
  TIME_SERIES: 'time_series',
  TABLE_VIEW: 'table_view',
  WIND_ROSE: 'wind_rose',
  FROST_PROBE: 'frost_probe',
};
export const SENSOR_PLACEMENT_CONFIG = {
  ID: -999999,
  SEG_ID: -9999,
  SOT_ID: -999,
  TOT_ID: -799,
  TPL_ID: -7999,
  PLACEMENT_TAG: 'sp',
  SEGMENT_TAG: 'seg',
  SOT_TAG: 'sot',
  TEMPLATE_TAG: 'tpl',
  MAPPINGS: ['Frost Probe', 'Snow Pole'], //sensor types which must match AWP.Common.Constants.cs
  NEW_SEGMENT_OBSERVATION_TYPE: {
    Id: -999,
    ObservationTypeId: null,
    ObservationTypeName: '',
    ObservationTypeDisplayName: '',
    DisplayName: null,
    IsValid: 'Y',
    SensorLayerNumber: null,
    RelativeElevationMillimetres: null,
    PlacementSegmentId: null,
    WeatherStationId: null,
    LastObservation: null,
    ConcurrencyControlNumber: null,
  },
  NEW_TEMPLATE_OBSERVATION_TYPE: {
    Id: -799,
    ObservationTypeId: null,
    ObservationTypeName: '',
    ObservationTypeDisplayName: '',
    DisplayName: null,
    PlacementTemplateId: -7999,
    ConcurrencyControlNumber: 0,
  },
};

//must match AWP.Common.Constants.cs
export const FROST_PROBE_CONFIG = {
  ID: -999999,
  SOT_ID: -900,
  DEFAULT_SOT_COUNT: 21, // number of subsfc_temp
  DATA_SOURCE: 'FrostProbe',
  TITLE_NAME: 'Frost Probe',
  SUBSFC_TEMP: 'subsfc_temp',
  SUBSFC_TEMP_TITLE: 'Subsurface Temp', //display name
  PRECISN_RESISTOR: 'precisn_resistor',
  FORST_PROBE_SENSOR_TYPE: 'Frost Probe',
  GROUP: 'Frost Probes',
  FROST_PROBE_HEAT_MAP: 'Frost Probe Heat Map',
  FROST_PROBE_OBS_NAME: 'frost_probe_heatmap',
  PAVEMENT_TEMP: 'Pavement Temperature',
};

//must match AWP.Common.Constants.cs
export const SNOW_POLE_CONFIG = {
  ID: -999999,
  SOT_ID: -800,
  DEFAULT_SOT_COUNT: 1, // number of snwpk_temp
  DATA_SOURCE: 'SnowPole',
  TITLE_NAME: 'Snow Pole',
  SNWPK_TEMP: 'snwpk_temp',
  SNWPK_TEMP_TITLE: 'Snwpk Temp', //display name
  //PRECISN_RESISTOR: 'precisn_resistor',
  SNOW_POLE_SENSOR_TYPE: 'Snow Pole',
  GROUP: 'Snow Poles',
  SNOW_POLE_OBS_NAME: 'snow_pole_heatmap',
};

//must match AWP.Common.Constants.cs
export const DATASET_PREFIX = {
  DEFAULT: '0',
  CAMERA: '1',
  WEATHERNET_ISSUED: '2',
  ENVIRONMENT_CANADA_ISSUED: '3',
  WEATHERNET: '4',
  ENVIRONMENT_CANADA: '5',
  FROST_PROBE: '150000',
  SNOW_POLE: '250000',
};

//must match AWP.Common.Constants.cs
export const DATASET_CONFIG = {
  CameraImagSensorTypeId: '-1',
  CameraImag_SensorTypeName: 'Images',
  CameraImagObservationTypeName: 'bc_drive_camera_image',

  WxNetIssuedForecastTypeAbbr: 'WNETPAVEMENT',
  WxNetIssuedForecastSensorTypeId: -2, //suggest negative data prefix
  WxNetIssuedForecastSensorTypeName: 'WeatherNet Pavement Issued Forecast',
  WxNetIssuedForecastPlacementName: 'WeatherNet Pavement Issued Forecast',
  WxNetPavement: 'WeatherNet Pavement',

  ECIssuedForecastTypeAbbr: 'ECPUBLIC',
  ECIssuedForecastSensorTypeId: -3, //suggest negative data prefix
  ECIssuedForecastSensorTypeName: 'Environment Canada Issued Forecast',
  ECIssuedForecastPlacementName: 'Environment Canada Issued Forecast',
};

export const ACCESS_REQUEST_STATUS = {
  GRANTED: 'Granted',
  DENIED: 'Denied',
  PENDING: 'Pending',
  NONE: 'None',
  EDITABLE_PENDING: 'EditablePending',
};

export const AccessRequestFormStatus = {
  Create: 'Create',
  Update: 'Update',
  Pending: 'Pending',
  SubmitSuccessful: 'SubmitSuccessful',
  SubmitFailed: 'SubmitFailed',
};

export const INI_START_DATE = '1000-01-01 00:00:01';
export const INI_END_DATE = '3000-01-01 00:00:01';

export const Permissions = {
  AdminDefault: 'ADMIN_DEFAULT',
  PostObservation: 'POST_OBSERVATION',
  ReadAdminTools: 'READ_ADMIN_TOOLS',
  ReadDataGraph: 'READ_DATA_GRAPH',
  ReadDataTable: 'READ_DATA_TABLE',
  ReadInventory: 'READ_INVENTORY',
  ReadMaps: 'READ_MAPS',
  ReadUserDashboard: 'READ_USER_DASHBOARD',
  ReadAvalanceForm: 'READ_AVALANCHE_FORM',
  ReadAlertDefinition: 'READ_ALERT_DEFINITION',
  ReadAvalancheHazard: 'READ_AVALANCHE_HAZARD',
  ReadVms: 'READ_VMS',
  ReadSysNotification: 'READ_SYS_NOTIFICATION',
  WriteAdminTools: 'WRITE_ADMIN_TOOLS',
  WriteCustomGraph: 'WRITE_CUSTOM_GRAPH',
  WriteDataTableManualValidation: 'WRITE_DATA_TABLE_MANUAL_VALIDATION',
  WriteGraphManualValidation: 'WRITE_GRAPH_MANUAL_VALIDATION',
  WriteObservationType: 'WRITE_OBSERVATION_TYPE',
  WriteSensorEquipment: 'WRITE_SENSOR_EQUIPMENT',
  WriteSensorModel: 'WRITE_SENSOR_MODEL',
  WriteSensorPlacement: 'WRITE_SENSOR_PLACEMENT',
  WriteSensorType: 'WRITE_SENSOR_TYPE',
  WriteWeatherStation: 'WRITE_WEATHER_STATION',
  WriteManufacturer: 'WRITE_MANUFACTURER',
  WriteAvalancheForm: 'WRITE_AVALANCHE_FORM',
  WritePersonalAlert: 'WRITE_PERSONAL_ALERT',
  WritePublicAlert: 'WRITE_PUBLIC_ALERT',
  WriteAvalancheHazard: 'WRITE_AVALANCHE_HAZARD',
  WritePublicPreset: 'WRITE_PUBLIC_PRESET',
  WriteVms: 'WRITE_VMS',
  WriteSysNotification: 'WRITE_SYS_NOTIFICATION',
  WriteVmsControl: 'WRITE_VMS_CONTROL',
  WriteSoilType: 'WRITE_SOIL_TYPE',
};

export const DASHBOARD_COMPLETENESS_COLOURS = [
  '#AAD454', // Green - Received Expected Data
  '#E62AE6', // Purple - Received Partial Data
  '#F62727', // Red - Missing Expected Data
  '#AEAEAE', // Grey - No Expected Data
  //'#5CC6FC', // Blue - Received Unexpected Data
];
export const DASHBOARD_QUALITY_COLOURS = [
  '#AAD454', // Green - Indicates valid data
  '#F62727', // Red - Indicates invalid data
];

export const DASHBOARD_TIMELINE_COLOURS = [
  '#AAD454', // Green - Indicates on time data
  '#F9F0BE', // Yellow - Indicates late data
];

export const DASHBOARD_COMPLETENESS_COLOUR_INDEX = {
  GREEN: 0, // Green - Received Expected Data
  PURPLE: 1, // Purple - Received Partial Data
  RED: 2, // Red - Missing Expected Data
  GREY: 3, // Grey - No Expected Data
  //BLUE: 4, // Blue - Received Unexpected Data
};

export const DASHBOARD_TIMELINENESS_COLOUR_INDEX = {
  GREEN: 0, // Green - Received Expected Data
  YELLOW: 1, // Yellow - Received late Data
};

export const DASHBOARD_COMPLETENESS_DESCRIPTIONS = [
  '% received successfully', // Green - Received Expected Data
  '% received partial data', // Purple - Received Partial Data
  '% missing expected data', // Red - Missing Expected Data
  '% no expected data', // Grey - No Expected Data
  //'received unexpected data', // Blue - Received Unexpected Data
];
export const DASHBOARD_QUALITY_DESCRIPTIONS = [
  '% valid data', // Green - Indicates valid data
  '% invalid data', // Red - Indicates invalid data
];

export const DASHBOARD_TIMELINE_DESCRIPTIONS = [
  '% received expected data', // Green - Indicates on-time data
  '% received late data', // Yellow - Indicates late data
];

export const DASHBOARD_DOUGHNUT_TYPES = {
  TIMELINESS: 'Timeliness',
  COMPLETENESS: 'Completeness',
  QUALITY: 'Quality',
};

export const DASHBOARD_TAB_KEY = {
  OVERVIEW: 'overview',
  TIMEBASED: 'time-based',
  GRAPH: 'graph',
  TABLE: 'table',
  TIMELINESS: 'timeliness',
  COMPLETENESS: 'completeness',
  QUALITY: 'quality',
};
export const AVA_DASHBOARD_DOUGHNUT_TYPES = {
  QUALITY: 'Quality',
};
export const AVA_DASHBOARD_QUALITY_DESCRIPTIONS = [
  '% ingested data', // Green - Indicates valid data
  '% ingest failed data', // Red - Indicates invalid data
];
export const AVA_DASHBOARD_TAB_KEY = {
  VISUAL: 'visual',
  TEXT: 'text',
  GRAPH: 'graph',
  TABLE: 'table',
  TIMELINESS: 'timeliness',
  COMPLETENESS: 'completeness',
  QUALITY: 'quality',
};
export const GRAPH_DISPLAY_DAYS = 4; // days on graph view
export const DATA_FETCH_DAYS = 30; // how many days worth of data to fetch
export const IMAGE_DATASET_SENSOR_TYPE_NAME = 'images';

export const GeneralUserRole = 'General User';
export const SystemAdminRole = 'System Administrator';

export const DATASET_TYPES = {
  Regular: 'Regular',
  FrostProbe: 'Frost Probe',
  SnowPole: 'Snow Pole',
  Image: 'Image',
  ForecastData: 'Forecast Data',
  CameraImage: 'Camera Image',
};

export const ACTION_PAGE_TYPE = {
  GRAPH: 'Graph',
  DATATABLE: 'DataTable',
};

export const FORM_MODE = {
  CREATE: 'create',
  EDIT: 'edit',
  LIST: 'list',
  VIEW: 'view',
  DELETE: 'delete',
  LEGEND: 'legend',
  TRANSMIT: 'transmit',
  REFRESH: 'refresh',
  SUBSCRIBE: 'subscribe',
  CLONE: 'clone',
};

export const ADDITIONAL_DATA_DIRECTION = {
  FORWARD: 'forward',
  BACKWARD: 'backward',
};

export const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
export const SESSION_KEEP_ALIVE_INTERVAL = 4 * 60 * 1000; // 4 minutes

export const OfflineFormStatus = {
  Valid: 'Valid',
  Invalid: 'Invalid',
  Submitted: 'Submitted',
  Duplicated: 'Duplicated',
};
export const formFailedStatus = {
  IngestFailed: 'IngestFailed',
  PushFailed: 'PushFailed',
};

export const EventTypes = {
  AvalancheControl: 'AVALANCHE CONTROL EVENT',
  AvalancheOccurrence: 'AVALANCHE EVENT',
  RoadClosure: 'ROAD CLOSURE EVENT',
  SweepStart: 'SWEEP PHASE START',
  SweepEnd: 'SWEEP PHASE END',
  ControlStart: 'CONTROL PHASE START',
  ControlEnd: 'CONTROL PHASE END',
  DepositRemovalStart: 'DEPOSIT REMOVAL START',
  DepositRemovalEnd: 'DEPOSIT REMOVAL END',
  MaintenanceStart: 'MAINTENANCE PHASE START',
  MaintenanceEnd: 'MAINTENANCE PHASE END',
  RoadClosureEnd: 'ROAD CLOSURE END',
  HazardForecast: 'AVALANCHE FORECAST EVENT',
  PhasedEvent: 'PhasedEvent', //no mappings to DB (internal use to refer phased events)
};

export const ParentEventTypes = [EventTypes.AvalancheOccurrence, EventTypes.AvalancheControl, EventTypes.RoadClosure];

export const PhasedEventTypes = {
  Mappings: [
    'SWEEP PHASE START',
    'SWEEP PHASE END',
    'CONTROL PHASE START',
    'CONTROL PHASE END',
    'DEPOSIT REMOVAL START',
    'DEPOSIT REMOVAL END',
    'MAINTENANCE PHASE START',
    'MAINTENANCE PHASE END',
    'ROAD CLOSURE END',
  ],
};

export const ProcessedEventStatus = {
  Open: 'Open',
  Closed: 'Closed',
};

export const RoadStatus = {
  Open: 'Open',
  Closed: 'Closed',
};

//mappings to DB:WAG_GEOGRAPHIC_AREA_TYPE
export const GeoAreaTypes = {
  CONTRACT: 'CONTRACT AREA',
  EET: 'EET SERVICE AREA',
  CONTRACT_DISPLAY: 'Maintenance Contractor Areas',
  EET_DISPLAY: 'EET Areas',
  DISPLAYS: ['Maintenance Contractor Areas', 'EET Areas'],
  TYPES: ['CONTRACT AREA', 'EET SERVICE AREA'], //mappings to DB:WAG_GEOGRAPHIC_AREA_TYPE
};

export const DATA_RANGE = {
  MAXIMUM: 31,
  MINIMUM: 1,
  CUSTOM: -1,
  DEFAULT: 4,
  MAXDATAUNIT: 2000, // max Data Unit(DU):1 DU = 1 dataset(observation type) * 1 day
};

export const ConditionProps = ['conditionId', 'observationType', 'operator', 'value'];

export const AllOperators = [
  { value: '=', label: '=' },
  { value: '!=', label: '!=' },
  { value: '<', label: '<' },
  { value: '<=', label: '<=' },
  { value: '>', label: '>' },
  { value: '>=', label: '>=' },
  { value: 'match', label: 'match' },
];

export const OperatorsForNonNumber = [
  { value: '=', label: '=' },
  { value: '!=', label: '!=' },
  { value: 'match', label: 'match' },
];

export const OperatorsForNumber = [
  { value: '=', label: '=' },
  { value: '!=', label: '!=' },
  { value: '<', label: '<' },
  { value: '<=', label: '<=' },
  { value: '>', label: '>' },
  { value: '>=', label: '>=' },
];

export const Usertypes = {
  Idir: 'idir',
  BceidBusiness: 'bceidbusiness',
  External: 'external',
};

export const EnabledFeature = {
  MultiWeatherStation: true,
  MultiStationPresets: true,
  WeatherForecastMap: false,
  VMS: true,
  WeatherStationPresetButton: true,
  ProcessedPhasedEventDeleteButton: true,
  FrostProbe: true,
  StandardGraphAxis: true,
  AlertGeoArea: true,
  AvalanchePaths: true,
  HazardForecastArea: true,
  SingleStationGraph: false,
  CodeTable: true,
};

export const ForecastLevel = {
  0: 'NO HAZARD',
  1: 'LOW',
  2: 'MODERATE',
  3: 'CONSIDERABLE',
  4: 'HIGH',
  5: 'EXTREME',
};
export const TIME_DASH_VIEW_COLORS_INDEX = {
  RED: 1, // Red - Missing Expected Data
  PURPLE: 2, // Purple - Received Partial Data
  BLUE: 3, // Blue - Received Invalid Data
  YELLOW: 4, // Yellow - Received late Data
  GREY: 5, // Grey - No Expected Data
  GREEN: 6, // Green - Received Expected Data
};
export const TIME_DASH_VIEW_COLORS = [
  '#F30806', // Red - Missing Expected Data
  '#CC04B5', // Purple - Received Partial Data
  '#0459D8', // Blue - Received Invalid Data
  '#FFFF00', // Yellow - Indicates late data
  '#CCCCCC', // Grey - No Expected Data
  '#37C603', // Green - Received Expected Data
];

export const TIME_DASH_VIEW_LEGEND = [
  'Missing expected data',
  'Received partial data',
  'Invalid data',
  'Received data late',
  'No expected data',
  'Received data on time',
];
export const WEATHERNET_PAVEMENT = {
  STATUS: 'Pavement Surface Status',
  TEMP: 'Temperature',
  STATUS_FORECASTED_HSL: 'hsl(216, 73.8%, 46.5%)',
  TEMP_FORECASTED_HSL: 'hsl(0, 0%, 0%)',
  TEMP_MEASURED_HSL: 'hsl(0, 100%, 50%)',
};

export const NULL_OPTION = { label: null, value: null, isDisabled: false, parentId: null };
export const DEFAULT_PRESET_ID_FOR_ALL_DATASETS = -999; //pseudo preset id for the default preset for non-graph
